<template>
  <v-card variant="outlined" rounded>
    <v-icon class="close-icon" @click="onHandleIconClick">mdi-close</v-icon>
    <v-card-title class="text-subtitle-1" v-if="headline">{{ headline }}</v-card-title>
    <v-card-text v-if="text"> {{ text }} </v-card-text>
    <v-card-text> <slot name="text"/> </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import type {PropType} from "vue";
import type { TranslateResult } from 'vue-i18n';

const props = defineProps({
  headline: {
    required: false,
    type: String as PropType<string | TranslateResult>,
    default: undefined
  },
  text: {
    required: false,
    type: String as PropType<string | TranslateResult>,
    default: undefined
  },
})

const emits = defineEmits([
  'onClose',
]);

const onHandleIconClick = () => {
  emits('onClose')
}

</script>
<style scoped>
.close-icon {
  position:absolute;
  right:0;
  margin:1rem;
}
</style>


